




















import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

import { getFreeOrderPrize } from '$services/free-order.ts'

const actModule = namespace('freeOrder')

@Component({
  name: 'free-order',
  components: {
  }
})
export default class FreeOrder extends Vue {
  @actModule.Getter integralInfo!: any
  data = []
  mounted() {
    getFreeOrderPrize()
      .then((res: any) => {
        if (res && res.length > 0) {
          const list = res.map((item: any) => {
            const pLen = item.prizeId.length
            if (pLen > 18) {
              item.prizeId = item.prizeId.substr(pLen - 18, pLen)
            }
            return item
          })
          this.data = list
        } else {
          this.$emit('noData')
        }
      })
  }
}
